import React from 'react'
import { Link } from 'react-router-dom';



function ContactUsButton() {
  return (
    <Link to={'/'} className='mt-2 dBtn btnSecondary shopbtn hasShadow'><span className='ms-2'>Shop Now</span></Link>
  )
}
export default ContactUsButton
